import { FabricImage, FabricObject } from "fabric";

class ImageObject {
  url: string;

  public object: FabricObject | undefined;

  public aspectRatio = 1;

  constructor(url: string) {
    this.url = url;
  }

  async init() {
    this.object = await FabricImage.fromURL(this.url);

    this.object.set({
      selectable: false,
      lockSkewingX: true,
      lockSkewingY: true,
      evented: false,
      hoverCursor: "default",
    });

    this.aspectRatio = this.getAspectRatio();
  }

  private getAspectRatio(): number {
    if (!this.object) throw new Error("Object not initialized");

    const { width, height } = this.object;

    return width / height;
  }

  scaleTo({ width, height }: { width: number; height: number }) {
    if (!this.object) throw new Error("Object not initialized");

    this.object.scaleToWidth(width);
    this.object.scaleToHeight(height);
  }
}

export default ImageObject;
